import react, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Table from "../../../Layout/Table/Table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BillingRequests from "../BillingRequests";
import { Puff } from "react-loading-icons";
import BillingNavigation from "../BillingNavigation";
import NavBar from "../../../../components/NavBar";

const BillingTransactions = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const ActionColumn = ({ id }) => {
    return (
      <div>
        <Link
          className="btn btn-primary"
          to={`/my/billing/checkout/${id}/finish`}
        >
          <i className="fa-solid fa-list me-3"></i>Detalhes
        </Link>
      </div>
    );
  };

  const StatusColumn = ({ status }) => {
    return (
      <div className={`status-column ${status.toString().toLowerCase()}`}>
        {status}
      </div>
    );
  };

  const columns = [
    "Nº Movimento",
    "Data",
    "Descrição",
    "Valor",
    "Estado",
    "Detalhes",
  ];

  const serializeRowsColums = () => {
    return data.map((item) => {
      // let obj = item;
      // obj["status"] = <StatusColumn status={obj.status} />;
      // obj["Actions"] = <ActionColumn id={obj.id} />;
      return {
        ...item,
        Detalhes: <ActionColumn id={item.id} />,
      };
    });
  };

  const handlerRequestList = async () => {
    setIsLoading(true);
    let info = await BillingRequests.getTransactionsList(params);
    if (info && info.status) {
      setData(info.data.list);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = "Transactions | Nightspot Dashboard";
    handlerRequestList();
  }, []);

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-8">
                    <h2 className="dashboard-h2">Lista de movimentos</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/nightspots">Lista Nightspots</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/billing/manager/${params.id_venues}`}>
                            Gestão de subscrição
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Lista de movimentos
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12">
                    <div className="row mt-3">
                      <div className="col-5 col-sm-3 ">
                        <BillingNavigation tab="transactions" />
                      </div>
                      <div className="col-7 col-sm-9 container">
                        <div className="row">
                          <div className="col-12 event-list-table">
                            <Table
                              columns={columns}
                              data={serializeRowsColums(data)}
                              currentPage={1}
                              itemsPerPage={10}
                              totalItems={data.length}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default BillingTransactions;
